import { AfterLoad, Column, Entity, JoinColumn, JoinTable, ManyToOne, OneToMany } from 'typeorm';
import { OrderedModel } from '@nsk-app/models/orderedModel';
import { Topic } from '@nsk-app/models/topic';
import { Moment } from '@nsk-app/models/moment';

@Entity({
  orderBy: {
    order: 'ASC'
  }
})
export class Phase extends OrderedModel {

  @Column()
  name: string;

  @Column()
  topic_id: string;

  @ManyToOne(type => Topic, topic => topic.phases, {lazy: true})
  @JoinColumn({name: 'topic_id'})
  topic: Promise<Topic>;

  @OneToMany(type => Moment, moment => moment.phase, {eager: true})
  moments?: Moment[];

  @AfterLoad()
  sortAttributes() {
    if (this?.moments?.length) {
      this.moments.sort((a, b) => (a.order < b.order ? -1 : a.order === b.order ? 0 : 1));
    }
  }
}
